/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const ControlContainUserAction = {
    Disable: 'disable',
    ResetPassword: 'reset_password',
    RevokeSessions: 'revoke_sessions'
} as const;
export type ControlContainUserAction = typeof ControlContainUserAction[keyof typeof ControlContainUserAction];


export function ControlContainUserActionFromJSON(json: any): ControlContainUserAction {
    return ControlContainUserActionFromJSONTyped(json, false);
}

export function ControlContainUserActionFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlContainUserAction {
    return json as ControlContainUserAction;
}

export function ControlContainUserActionToJSON(value?: ControlContainUserAction | null): any {
    return value as any;
}

